import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LogoCompleta from "../../../../../assets/logonotify1.png";
import LogoIcone from "../../../../../assets/notifyicone.png";
import './Grupos.css';
import { FaPlus, FaEdit, FaUpload, FaSync, FaDownload, FaUsers } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa";
import { FaEllipsisV } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import ExportarGrupos from "./Exportargrupos";
import ModalAlterarGrupo from "./ModalAlterarGrupo";
import ModalCriarGrupo from "./ModalCriarGrupo";
import PrivateMenuLeft from "../../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../../sections/Header/privateMenuUp";
import PrivateMenuCampanha from "../privateMenuCampanha";
import useAuth from "../../../../../components/hooks/useAuth";
import { Helmet } from "react-helmet";
import GrupoItem from "./GroupItem";
import Loader from "../../../../../components/Loader";
import ImportGroupCampaignModalComponent from "./modalImportGroup";

const HEADER_HEIGHT = 56;

const Grupos = () => {
  const [cheioGrupos, setCheioGrupos] = useState([true, false, true]); // exemplo para 3 grupos
  const [marcados, setMarcados] = useState([]);
  const [menuAberto, setMenuAberto] = useState(null);
  const [modalCriarGrupo, setModalCriarGrupo] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 5; // Número de grupos por página
  const navigate = useNavigate();
  const [modalAtualizarLink, setModalAtualizarLink] = useState(false);
  const [modalExportarLeads, setModalExportarLeads] = useState(false);
  const [modalExportarGrupos, setModalExportarGrupos] = useState(false);
  const [stmodalAlterarGrupo, setStModalAlterarGrupo] = useState();
  const [stModalImportGroup, setStModalImportGroup] = useState();

  const [loading, setLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);

  const { id: campaignId } = useParams();
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();


  const buttonStyle = {
    background: "#51a197",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "16px 12px",
    fontWeight: "bold",
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    gap: 10,
    cursor: "pointer",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    width: "100%",
    justifyContent: "center"
  };



  const handleCopiarLink = (link) => {
    if (link == null) {
      window.alert("O link ainda não foi gerado. Tente verificar o status da conexão das contas vinculadas.");
    }
    navigator.clipboard.writeText(link);
    window.alert("O link foi copiado com sucesso.");

  };

  const updateGroupsLink = async () => {

    setLoading(true);
    try {
      let response = await postApi("/api/v1/campaign/groups/updateLink/all/" + campaignId, {
      });
    } catch (error) {
      window.alert("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {
      loadGroupRequest();
      setModalAtualizarLink(false);
    }
  }


  const totalPaginas = Math.ceil(cheioGrupos.length / itensPorPagina);

  const loadGroupRequest = async () => {

    setLoading(true);
    try {
      let response = await postApi("/api/v1/campaign/groups/list", {
        queryString: {
          campaign: {
            'id': campaignId
          }
        }
      });
      setGroupList(response.lista)
    } catch (error) {
      window.alert("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoading(false);
    }
  }

  useEffect(() => {

    loadGroupRequest();

  }, [campaignId]);



  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 - por cima do header */}

      <PrivateMenuLeft />
      <PrivateMenuUp />


      <Helmet>
        <title>{`Listagem de grupos da campanha`}</title>
      </Helmet>


      <div
        style={{
          marginLeft:
            window.innerWidth <= 768
              ? 56 // Sempre 56px no mobile, independente do sidebarOpen
              : sidebarOpen
                ? 220
                : 70,
          paddingTop: HEADER_HEIGHT,
          width:
            window.innerWidth <= 768
              ? "calc(100vw - 56px)" // Sempre 56px no mobile
              : sidebarOpen
                ? "calc(100% - 220px)"
                : "calc(100% - 70px)",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        }}
      >
        <PrivateMenuCampanha />

      </div>

      {/* Conteúdo da página de grupos */}
      <div style={{
        position: "relative",
        zIndex: 1,
        marginLeft: window.innerWidth > 768 ? 70 : 56,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? "calc(100% - 70px)"
          : "calc(100vw - 56px)",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        minHeight: "100vh",
        boxSizing: "border-box",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 32
      }}>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: window.innerWidth <= 768 ? "1fr 1fr" : "repeat(4, 1fr)",
            gap: 16,
            width: window.innerWidth <= 768 ? "100%" : 700,
            marginTop: window.innerWidth <= 768 ? 24 : 8, // <-- Aqui: desktop fica só 8px após o header!
            justifyItems: "center"
          }}
        >
          <button style={buttonStyle} onClick={() => setModalCriarGrupo(true)}>
            <FaPlus size={20} />Criar Grupos
          </button>
          {/* <button style={buttonStyle} onClick={() => setModalAlterarGrupo(true)}>
            <FaEdit size={20} />Alterar Grupos
          </button> */}
          <button style={buttonStyle}
            onClick={e => setStModalImportGroup(true)}
          ><FaUpload size={20} />Importar Grupos</button>
          <button style={buttonStyle} onClick={() => setModalAtualizarLink(true)}>
            <FaSync size={20} />Atualizar Link
          </button>
          <button style={buttonStyle} onClick={() => setModalExportarGrupos(true)}>
            <FaDownload size={20} />Exportar Grupos
          </button>
          <button style={buttonStyle} onClick={() => setModalExportarLeads(true)}>
            <FaUsers size={20} />Exportar Leads
          </button>
        </div>

        {/* Input de busca */}
        <div style={{
          width: "100%",
          maxWidth: 420,
          margin: "32px auto 0 auto",
          display: "flex",
          justifyContent: "center"
        }}>
          <input
            type="text"
            placeholder="Buscar grupos..."
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: 8,
              border: "1px solid #51a197",
              fontSize: 16,
              outline: "none"
            }}
          // onChange={...} // coloque sua lógica de busca aqui
          />
        </div>

        {/* Botões Marcar tudo e Excluir - logo abaixo do input */}
        {marcados.length > 0 && (
          <div style={{
            width: "100%",
            maxWidth: 420,
            margin: "12px auto 0 auto",
            display: "flex",
            gap: 16,
            justifyContent: "flex-start"
          }}>
            <button
              style={{
                background: "#51a197",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 18px",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer"
              }}
              onClick={() => setMarcados([1, 2, 3])} // Marcar tudo (ajuste para seu array real)
            >
              Marcar tudo
            </button>
            <button
              style={{
                background: "#e74c3c",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 18px",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer"
              }}
              onClick={() => setMarcados([])}
            >
              Excluir
            </button>
          </div>
        )}

        {/* Lista de grupos com paginação */}
        <div style={{
          width: "100%",
          maxWidth: 700,
          margin: "24px auto 0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 18
        }}>

          {loading && <Loader />}
          {/* Renderiza os grupos da página atual */}
          {groupList.map((el, idx) => (
            <GrupoItem
              key={el.id}
              idx={idx} el={el} marcados={marcados} setMarcados={setMarcados}
              handleCopiarLink={handleCopiarLink}
              setStModalAlterarGrupo={setStModalAlterarGrupo}
              loadGroupRequest={loadGroupRequest} />
          ))}


          {/* Botões de paginação */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            marginTop: 16
          }}>
            <button
              onClick={() => setPaginaAtual(paginaAtual - 1)}
              disabled={paginaAtual === 1}
              style={{
                background: paginaAtual === 1 ? "#e0e0e0" : "#51a197",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 12px",
                fontWeight: "bold",
                fontSize: 14,
                cursor: paginaAtual === 1 ? "not-allowed" : "pointer"
              }}
            >
              Anterior
            </button>
            {Array.from({ length: totalPaginas }, (_, i) => (
              <button
                key={i}
                onClick={() => setPaginaAtual(i + 1)}
                style={{
                  background: paginaAtual === i + 1 ? "#005c53" : "#51a197",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "8px 12px",
                  fontWeight: "bold",
                  fontSize: 14,
                  cursor: "pointer"
                }}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => setPaginaAtual(paginaAtual + 1)}
              disabled={paginaAtual === totalPaginas}
              style={{
                background: paginaAtual === totalPaginas ? "#e0e0e0" : "#51a197",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 12px",
                fontWeight: "bold",
                fontSize: 14,
                cursor: paginaAtual === totalPaginas ? "not-allowed" : "pointer"
              }}
            >
              Próxima
            </button>
          </div>
        </div>


        {modalAtualizarLink && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                width: "90%",
                maxWidth: 400,
                boxShadow: "0 2px 16px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
              }}
            >
              <h2 style={{ color: "#005c53", fontWeight: "bold", marginBottom: 16 }}>
                Atualizar link dos grupos
              </h2>
              <p style={{ color: "#333", fontSize: 16, marginBottom: 24 }}>
                Tem certeza que deseja realizar essa operação?
              </p>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <button
                  onClick={() => setModalAtualizarLink(false)}
                  style={{
                    background: "#e0e0e0",
                    color: "#005c53",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Não
                </button>
                <button
                  onClick={() => {
                    updateGroupsLink();
                    console.log("Link atualizado!"); // Substitua pela lógica de atualização
                  }}
                  style={{
                    background: "#51a197",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Sim
                </button>
              </div>
            </div>
          </div>
        )}

        {modalExportarLeads && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                width: "90%",
                maxWidth: 400,
                boxShadow: "0 2px 16px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
              }}
            >
              <h2 style={{ color: "#005c53", fontWeight: "bold", marginBottom: 16 }}>
                Exportar Leads
              </h2>
              <p style={{ color: "#333", fontSize: 16, marginBottom: 24 }}>
                Tem certeza que deseja exportar os leads?
              </p>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <button
                  onClick={() => setModalExportarLeads(false)}
                  style={{
                    background: "#e0e0e0",
                    color: "#005c53",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Não
                </button>
                <button
                  onClick={() => {
                    setModalExportarLeads(false);
                    console.log("Leads exportados!"); // Substitua pela lógica de exportação
                  }}
                  style={{
                    background: "#51a197",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Sim
                </button>
              </div>
            </div>
          </div>
        )}

        {modalExportarGrupos && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                width: "90%",
                maxWidth: 400,
                boxShadow: "0 2px 16px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
              }}
            >
              <h2 style={{ color: "#005c53", fontWeight: "bold", marginBottom: 16 }}>
                Exportar Grupos
              </h2>
              <p style={{ color: "#333", fontSize: 16, marginBottom: 24 }}>
                Tem certeza que deseja exportar os grupos da campanha?
              </p>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <button
                  onClick={() => setModalExportarGrupos(false)}
                  style={{
                    background: "#e0e0e0",
                    color: "#005c53",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Não
                </button>
                <button
                  onClick={() => {
                    setModalExportarGrupos(false);
                    ExportarGrupos(); // Chama a funcionalidade de exportar grupos
                  }}
                  style={{
                    background: "#51a197",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer",
                    flex: 1,
                  }}
                >
                  Sim
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
      <ModalCriarGrupo
        modalCriarGrupo={modalCriarGrupo}
        setModalCriarGrupo={setModalCriarGrupo}
        loadGroupRequest={loadGroupRequest}
        campaignId={campaignId}
      />

      {stmodalAlterarGrupo &&
        <ModalAlterarGrupo
          setStModalAlterarGrupo={setStModalAlterarGrupo}
          loadGroupRequest={loadGroupRequest}
          campaignId={campaignId}
          key={stmodalAlterarGrupo}
          group_id={stmodalAlterarGrupo}
        />

      }

      <ImportGroupCampaignModalComponent
        showModalImport={stModalImportGroup}
        setShowModalImport={setStModalImportGroup}
        loadGroupRequest={loadGroupRequest} />


    </div>
  );
};

export default Grupos;